import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import KenColors from '../../themes/KenColors';
import { Box, Grid, useTheme } from '@material-ui/core';
import KenCard from '../../components/KenCard/index';
import Header from '../Header';
import SignIn from './signIn';
import countryCodes from '../../json/countryISDCode.json';
import { useHistory } from 'react-router-dom';
import Register from './signUp';
import Carousel from 'react-material-ui-carousel';
import configContext from '../../utils/config';

const options = countryCodes.codes;

const useStyles = makeStyles((theme) => ({
  header: {
    padding: 8,
    boxShadow: `0px 0px 9px ${theme.palette.KenColors.shadowColor}`,
  },

  banner: {
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    alignItems: 'normal',
    position: 'relative',
  },
  bannerImg: {
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
    // cursor: "pointer",
  },

  bannerImgMultiple: {
    width: '100%',
    height: '630px',
    [theme.breakpoints.down('md')]: {
      height: 'auto',
      paddingTop: '15px',
    },

    // cursor: "pointer",
  },
  formDetails: {
    height: '100%',
    width: '454px',
    position: 'absolute',
    top: '14px',
    right: '6px',
    [theme.breakpoints.down('sm')]: {
      position: 'initial',
      padding: 12,
      marginTop: '15px',
    },
  },
  boxParent: {
    position: 'relative',
  },
  carouselwrap: {
    height: '100%',
  },
  imgWrapper: {
    height: '100%',
  },
  carouselWrapMultiple: {
    width: '100%',
  },
  right: {
    height: '100%',
    padding: '10px',
  },
  gridContainer: {
    [theme.breakpoints.down('sm')]: {
      paddingTop: '10px',
    },
  },
}));

export default function CroppedLayout(props) {
  const [signActive, setSignActive] = useState(true);
  const [existingActive, setExistingActive] = useState(false);
  const { handleSnackbarOpen } = props;
  const [open, setOpen] = React.useState(false);
  const { config } = React.useContext(configContext);
  const [user, setUser] = useState({ firstName: '', lastName: '' });
  const history = useHistory();
  const landingConfig = config;

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = (event, reason, submitted) => {
    setOpen(false);
  };
  const classes = useStyles();
  const theme = useTheme();
  const toggle = () => {
    setSignActive(!signActive);
    setExistingActive(!existingActive);
  };

  const isCarousel = landingConfig?.banner?.images?.length >= 2;
  return (
    <React.Fragment>
      <Grid container xs={12}>
        <Grid item xs={12} className={classes.header}>
          <Header
            isLogo={false}
            instituteDetails={landingConfig.supportText}
            firstName={user.First_Name}
            lastName={user.Last_Name}
          />
        </Grid>

        <Grid
          container
          item
          direction="row"
          justify="space-between"
          xs={12}
          className={classes.gridContainer}
          spacing={1}
        >
          <Grid item xs={12} md={12} lg={8} alignContent="center">
            <Box
              className={
                !isCarousel
                  ? classes.carouselWrap
                  : classes.carouselWrapMultiple
              }
              style={{ height: `${!isCarousel ? '100%' : ''}` }}
            >
              {!isCarousel ? (
                <div className={classes.imgWrapper}>
                  <img
                    src={
                      landingConfig?.banner?.images &&
                      Array.isArray(landingConfig?.banner?.images) &&
                      landingConfig.banner.images.length > 0
                        ? landingConfig.banner.images[0].url
                        : ''
                    }
                    className={classes.bannerImg}
                  ></img>
                </div>
              ) : (
                <Carousel
                  className={classes.carouselwrap}
                  autoplay={true}
                  interval={4000}
                >
                  {landingConfig?.banner?.images?.map((item, i) => (
                    <div className={classes.imgWrap}>
                      <img
                        src={item.url}
                        className={classes.bannerImgMultiple}
                      ></img>
                    </div>
                  ))}
                </Carousel>
              )}
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={12}
            lg={4}
            style={{
              //   backgroundColor: theme.palette.KenColors.tertiaryPurple450,
              backgroundColor:
                landingConfig?.banner?.rightPaneBgColor ||
                theme.palette.KenColors.tertiaryPurple450,
            }}
          >
            <Box className={classes.right}>
              <KenCard>
                <Box className={classes.boxParent}>
                  {signActive === true && (
                    <Register
                      options={[]}
                      retrieve={true}
                      toggle={toggle}
                      notify={true}
                      handleClose={handleClose}
                      handleSnackbarOpen={handleSnackbarOpen}
                    ></Register>
                  )}
                  {existingActive === true && (
                    <SignIn
                      retrieve={true}
                      toggle={toggle}
                      notify={true}
                      handleClose={handleClose}
                      handleSnackbarOpen={handleSnackbarOpen}
                    />
                  )}
                </Box>
              </KenCard>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
